import { useContext, useEffect, useState } from "react";
import { isAxiosError } from "axios";
import { AuthContext } from "../components/AuthContextComponent";
import { updateTheme } from "../api/FetchAPI";
import { showConnectionError } from "../promptMessages/PromptMessages";
import { ALERTMSG } from "../lib/enums/AlertMsgs";
import useUserLogin from "./UserLoginhook";

const useTheme = () => {
  const { userInfo, username, setUserData } = useContext(AuthContext);
  const { customColor } = useUserLogin();
  const [theme, setTheme] = useState(userInfo?.theme || "LIGHT");

  useEffect(() => {
    if (theme === "DARK") {
      document.documentElement.classList.add("DARK");
    } else {
      document.documentElement.classList.remove("DARK");
    }
  }, [theme]);

  const handleThemeSwitch = async () => {
    const newTheme = theme === "DARK" ? "LIGHT" : "DARK";
    setTheme(newTheme);

    try {
      const response: any = await updateTheme(username, newTheme);
      if (response.respCode === 2000) {
        // Create a new userInfo object with the updated theme
        const updatedUserData: any = {
          ...userInfo, // Spread existing userInfo properties
          theme: newTheme, // Update the theme
        };

        setUserData(updatedUserData); // Update the context state
        localStorage.setItem("userInfo", JSON.stringify(updatedUserData)); // Update localStorage
      }
    } catch (error: any) {
      const code = isAxiosError(error)
        ? error.request.status || error.code
        : error.response.status || error.code;
      showConnectionError(
        ALERTMSG.UNDHANDLEDERR,
        `${code}`,
        "error",
        theme === "DARK" ? "#24292e" : "",
        customColor,
        theme === "DARK" ? "#fafbfc" : ""
      );
    }
  };

  return { theme, handleThemeSwitch };
};

export default useTheme;
